module.exports = __webpack_public_path__ + "img/horizontal_7_4_7005.9961dd97.png";